import { defineMessages } from 'react-intl';

const messages = defineMessages({
  approve: {
    description: 'Action description to approve a return request',
    defaultMessage: 'Approve',
    id: '+nnpfd',
  },
  reject: {
    description: 'Action description to reject a return request',
    defaultMessage: 'Reject',
    id: 'fA6inc',
  },
  printLabel: {
    description: 'Action description to print a return request label',
    defaultMessage: 'Print',
    id: 'hXKkhw',
  },
  resendLabel: {
    description: 'Action description to resend a return request',
    defaultMessage: 'Resend Shipping Label',
    id: 'l7KnBu',
  },
  cancelRequest: {
    description: 'Action description to cancel a return request',
    defaultMessage: 'Cancel',
    id: '4WSaIm',
  },
  sendPaymentReminder: {
    description: 'Action description to send a payment reminder to the buyer',
    defaultMessage: 'Send Payment Reminder',
    id: 'vyv9db',
  },
  successContent: {
    description: 'Content for a success message',
    defaultMessage: 'You did it.',
    id: 'C701Py',
  },
  viewOnMarketplace: {
    description: 'Action description to view a return request on the marketplace',
    defaultMessage: 'View on {marketplaceName}',
    id: 'azPjp9',
  },
  cancelSuccessTitle: {
    description: 'Content for a success message after cancelling a return request',
    defaultMessage: 'Return request has been cancelled.',
    id: 'wIvi14',
  },
  sendPaymentSuccessTitle: {
    description: 'Title for a success message after resending a payment reminder',
    defaultMessage: 'Payment reminder sent!',
    id: 'omstEf',
  },
  sendPaymentSuccessContent: {
    description: 'Content for a success message after resending a payment reminder',
    defaultMessage: 'The payment reminder has been sent to {email} successfully.',
    id: 'Nxgghv',
  },
  resendLabelSuccessTitle: {
    description: 'Title for a success message after resending a label',
    defaultMessage: 'Return label sent!',
    id: 'X+yf5/',
  },
  resendLabelSuccessContent: {
    description: 'Content for a success message after resending a label',
    defaultMessage: 'The return label has been sent to {count, plural, one {# recipient} other {# recipients}} successfully.',
    id: '0jdD+h',
  },
  approveSuccessTitle: {
    description: 'Title for a success message after approving a return request',
    defaultMessage: 'Return request approved!',
    id: 'Zirb/6',
  },
  rejectSuccessTitle: {
    description: 'Title for a success message after rejecting a return request',
    defaultMessage: 'Return request rejected!',
    id: 'EYH8EX',
  },
  statusProcessed: {
    description: 'Status label for a processed return request.',
    defaultMessage: 'Processed',
    id: '+mficU',
  },
  statusCancelled: {
    description: 'Status label for a cancelled return request',
    defaultMessage: 'Cancelled',
    id: '1gEQBX',
  },
  resendLabelModalDescription: {
    description: 'Description text for the resend label modal',
    defaultMessage:
      'You can re-send the shipping label to your customers. Enter the recipient email address (for multiple emails, separate with a comma or press enter).',
    id: 'peV7iX',
  },
});

export default messages;
